module.exports = __webpack_public_path__ + "static/media/icn_lightbox_next.1a0eb594.svg";